import { type FlattenSimpleInterpolation, css } from "styled-components";
import { type BodyTextProps, TextAlignment } from "../TextProps";

export const DefaultBodyStyles = (
  props: BodyTextProps,
): FlattenSimpleInterpolation => {
  const textAlign = props.alignment ?? TextAlignment.LEFT;
  const color = props.textColor ?? "var(--colour-black)";

  return css`
    max-width: 75ch;
    font-family: var(--font-helvetica);
    text-transform: initial;
    text-align: ${textAlign};
    color: ${color};
    margin: 0;
    position: relative;
  `;
};
